/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_Save_FailedInputs */

const en_settings_profile_save_failed = /** @type {(inputs: Settings_Profile_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to save`)
};

const zh_settings_profile_save_failed = /** @type {(inputs: Settings_Profile_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存失败`)
};

/**
* | output |
* | --- |
* | "Failed to save" |
*
* @param {Settings_Profile_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_profile_save_failed = /** @type {((inputs?: Settings_Profile_Save_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_Save_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_save_failed(inputs)
	return zh_settings_profile_save_failed(inputs)
});
export { settings_profile_save_failed as "settings.profile.save_failed" }